import React, { createContext, useState, useContext } from 'react';


export const TemplateContext = createContext();

export const TemplateProvider = ({ children }) => {
  const [template, setTemplate] = useState({
    nombre: '',
    preguntas: []
  });
  const [questions, setQuestions] = useState([]);
  // Método para actualizar la plantilla seleccionada y sus preguntas
  const updateTemplate = (nombre, preguntas) => {
    setTemplate({
      nombre,
      preguntas
    });
  };
  const [participantes, setParticipantes] = useState([]);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');

  const updateFechaInicio = (fecha) => {
    setFechaInicio(fecha);
  };

  const updateFechaFin = (fecha) => {
    setFechaFin(fecha);
  };


  const updateParticipantes = (newParticipantes) => {
    setParticipantes(newParticipantes);
  };

  const updateQuestions = (newQuestions) => {
    console.log('Actualizando preguntas en el contexto:', newQuestions); // Punto 1
    setQuestions(newQuestions);
  };
  
  return (
    <TemplateContext.Provider value={{ template, 
      updateTemplate,
      questions,
      updateQuestions,
      participantes, 
      updateParticipantes,
      fechaInicio,
      updateFechaInicio,
      fechaFin,
      updateFechaFin, 
      }}>
      {children}
    </TemplateContext.Provider>
  );
};

export const useTemplate = () => useContext(TemplateContext);